import React from "react";

export const NormalFaceEmojiSvg = ({ width, height }) => (
  <svg
    width={width ?? "28"}
    height={height ?? "28"}
    viewBox={`0 0 ${width ?? "28"} ${height ?? "28"}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 9C18 13.9705 13.9705 18 9 18C4.03 18 0 13.9705 0 9C0 4.03 4.03 0 9 0C13.9705 0 18 4.03 18 9Z"
      fill="#FFCC4D"
    />
    <path
      d="M5.75 10.0007C6.44036 10.0007 7 9.2172 7 8.2507C7 7.2842 6.44036 6.5007 5.75 6.5007C5.05964 6.5007 4.5 7.2842 4.5 8.2507C4.5 9.2172 5.05964 10.0007 5.75 10.0007Z"
      fill="#664500"
    />
    <path
      d="M12.2507 10.0007C12.9411 10.0007 13.5007 9.2172 13.5007 8.2507C13.5007 7.2842 12.9411 6.5007 12.2507 6.5007C11.5603 6.5007 11.0007 7.2842 11.0007 8.2507C11.0007 9.2172 11.5603 10.0007 12.2507 10.0007Z"
      fill="#664500"
    />
    <path
      d="M12.4986 12.9995H5.49857C5.22257 12.9995 4.99857 12.776 4.99857 12.4995C4.99857 12.223 5.22257 11.9995 5.49857 11.9995H12.4986C12.7751 11.9995 12.9986 12.223 12.9986 12.4995C12.9986 12.776 12.7751 12.9995 12.4986 12.9995Z"
      fill="#664500"
    />
  </svg>
);
